/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import history from '../../core/history';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class Link extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node,
    onClick: PropTypes.func,
  };

  state = {
    colors: 'normal',
    style: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (this.props.style) {
      style = this.props.style;
    } else if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
      };
    }
    this.setState({ colors, style });
  }

  handleClick = (event) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    document.cookie = 'redirectURL=' + this.props.to;
    event.preventDefault();
    history.push(this.props.to);
  };

  render() {
    const { to, children, ...props } = this.props;
    return (
      <a
        href={to}
        {...props}
        onClick={this.handleClick}
        style={this.state.style}
      >
        {children}
      </a>);
  }
}

export default Link;



// WEBPACK FOOTER //
// src/components/Link/Link.js